import {
  PieChart,
  Pie,
  Cell,
  Tooltip,
  ResponsiveContainer,
} from "recharts";

const DefaultTooltip = ({ active, payload }) => {
  if (active && payload && payload.length) {
    const data = payload[0];

    return (
      <div
        style={{
          background: "#fff",
          border: "1px solid #ddd",
          padding: "8px 12px",
          borderRadius: "8px",
          boxShadow: "0 2px 6px rgba(0,0,0,0.1)",
        }}
      >
        <p style={{ margin: 0, fontWeight: 600 }}>{data.name}</p>
        <p style={{ margin: 0, color: data.payload.color }}>
          Value: {data.value}
        </p>
      </div>
    );
  }

  return null;
};

const CustomPieChart = ({
  title,
  data = [],
  height = 313,
  outerRadius = "80%",
  showLegend = true,
  tooltipComponent,
}) => {
  const TooltipComponent = tooltipComponent || DefaultTooltip;

  return (
    <div className="custom-graph-card-1" >
      {title && <h5 className="common-heading">{title}</h5>}

      <div style={{ height }}>
        <ResponsiveContainer width="100%" height="100%">
          <PieChart>
            <Pie
              data={data}
              dataKey="value"
              cx="50%"
              cy="50%"
              outerRadius={outerRadius}
              isAnimationActive
            >
              {data.map((entry, index) => (
                <Cell key={`cell-${index}`} fill={entry.color} />
              ))}
            </Pie>

            <Tooltip content={<TooltipComponent />} />
          </PieChart>
        </ResponsiveContainer>
      </div>

      {showLegend && (
        <div
          className="custom-legend"
          style={{ justifyContent: "center", display: "flex", gap: "12px", flexWrap: "wrap" }}
        >
          {data.map((item, index) => (
            <div key={index} className="legend-box" style={{ display: "flex", alignItems: "center", gap: "6px" }}>
              <div
                className="small-circle"
                style={{
                  background: item.color,
                  width: 10,
                  height: 10,
                  borderRadius: "50%",
                }}
              />
              <h5 style={{ color: item.color, margin: 0 }}>
                {item.name}
              </h5>
            </div>
          ))}
        </div>
      )}
    </div>
  );
};

export default CustomPieChart;